import styled from 'styled-components';
import { Text, Flexbox } from '@morressier/ts';
import { LinkButton } from '../Button';

export const Container = styled(Flexbox)<{ showExitContainer: boolean }>`
  height: 100%;
  display: ${({ showExitContainer }) => (showExitContainer ? 'block' : 'none')};
`;

export const Content = styled(Flexbox)`
  height: 100%;
  overflow-y: auto;
  padding: 32px;
  background-color: var(--color-mono-99);
  text-align: center;
`;

export const ExitButton = styled(LinkButton)`
  color: var(--color-red-50);
  &:hover,
  &:focus {
    color: var(--color-red-30);
  }
`;

export const Description = styled(Text)`
  width: 34rem;
  margin-bottom: 2rem;
`;

export const ModalImage = styled.img`
  margin-bottom: 2rem;
  max-height: 480px;
  min-height: 100px;
`;
